import { render } from "./field_type_button.vue?vue&type=template&id=620d4794"
import script from "./field_type_button.vue?vue&type=script&lang=js"
export * from "./field_type_button.vue?vue&type=script&lang=js"

import exportComponent from "/home/aptask/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__